<div class="spinner-border border-right-primary-400 border-primary-100" role="status">
  <span class="visually-hidden" i18n>Trwa wczytywanie...</span>
</div>
